const breakInside = {
    name: "break-inside",
    path: "/break-inside",
    title: "break-inside",
    description: "Utilities for controlling how a column or page should break within an element.",
    value: {
        "break-inside": {
            "break-inside-auto": "auto",
        "break-inside-avoid": "avoid",
        "break-inside-avoid-page": "avoid-page",
        "break-inside-avoid-column": "avoid-column",
        }
    },
    exampleData: [
        {
            "title": "break-inside-column, break-inside-avoid-page",
            "description": "utilities like to control how a column or page break should behave within an element:",
            "moreDescription": "",
            "parentClass": "",
            "example": {
                "element": "",
                "src": [],
                "className": "",
                "code": `<div class="columns-2">
  <p>Well, let me tell you something, ...</p>
  <p class="break-inside-avoid-column">Sure, go ahead, laugh...</p>
  <p>Maybe we can live without...</p>
  <p>Look. If you think this is...</p>
</div>`
            }
        },
        {
            "title": "break-inside",
            "description": "utility with a breakpoint variant like md: to only apply the utility at medium screen sizes and above:",
            "moreDescription": "",
            "parentClass": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<div class="break-inside-avoid-column md:break-inside-auto ...">
  <!-- ... -->
</div>`
            }
        }
    ]
}
export default breakInside;